import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../Layout/DocumentationSidebar";
import TopMenu from "../../TopMenu";
import TableDocument from "../../TableDocument";
import FilterModal from "../../../../Components/Common/FilterModal";
import { get } from "../../../../utils/api";
import { useUser } from "../../../../context/AuthContext";

const API_BASE = "/scope3/downstreamLeasedAssets";

/** Documents API may nest master asset under `lam`; list view uses `assetId` populate. */
const mapLeasedAssetsDocumentRow = (item) => ({
  ...item,
  assetID:
    item?.lam?.assetId ??
    item?.assetId?.assetId ??
    item?.assetId?._id ??
    item?.assetID ??
    "",
  typeofAsset:
    item?.lam?.typeOfAsset ??
    item?.assetId?.typeOfAsset ??
    item?.typeofAsset ??
    item?.typeOfAsset ??
    "",
});

const DownstreamLeasedAssetsDocuments = () => {
  const { user } = useUser();
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const columnWidth = user?.companyAdmin
    ? "10% 11% 12% 14% 14% 14% 13% 6%"
    : "11% 13% 15% 16% 16% 16% 7%";

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [url, setUrl] = useState("road");
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const [filter, setFilter] = useState({
    typeOfAsset: [],
    country: [],
  });

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
  };

  const handleToggle = (option, nextUrl) => {
    setSelectedOption(option);
    setUrl(nextUrl);
  };

  let filtersToApply = {};

  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page,
        facilityList: selectedFacility.join(","),
        limit: 10,
        search: searchQuery,
      }).toString();

      const response = await get(
        `${API_BASE}/documents?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}`
      );
      const rows = response.data.data || [];
      setData(rows.map(mapLeasedAssetsDocumentRow));
      setTotalPages(response.data.totalPages);
      setPage(response.data.currentPage);
    } catch (error) {
      console.error("Error fetching downstream leased assets documents:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, url, fromDate, toDate, selectedFacility, searchQuery]);

  // const fetchFilter = async () => {
  //   try {
  //     const response = await get(`${API_BASE}/filter`);
  //     const { typeOfAsset, country } = response.data?.data || {};
  //     setFilter({
  //       typeOfAsset: typeOfAsset || [],
  //       country: country || [],
  //     });
  //   } catch (error) {
  //     console.error(
  //       "Error fetching downstream leased assets document filters:",
  //       error
  //     );
  //   }
  // };

  // useEffect(() => {
  //   fetchFilter();
  // }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const heading = [
    { title: "Date", key: "createdAt" },
    user?.companyAdmin
      ? { title: "Facility", key: "facilityName" }
      : null,
    { title: "Consumption Month", key: "consumptionPeriod" },
    { title: "Asset ID", key: "assetID" },
    { title: "Type of Asset", key: "typeofAsset" },
    { title: "Asset size", key: "assetSize" },
    { title: "Electricity (MWH)", key: "electricityConsumption" },
  ].filter(Boolean);

  const filterData = [
    { title: "Date", type: "date", key: "date", value: [] },
    { title: "Lease Start Date", type: "date", key: "leaseStartDate", value: [] },
    {
      title: "Consumption Month",
      type: "month",
      key: "consumptionPeriod",
      value: [],
    },
    {
      title: "Type of Asset",
      type: "option",
      key: "typeOfAsset",
      value: filter.typeOfAsset || [],
    },
    {
      title: "Country",
      type: "option",
      key: "country",
      value: filter.country || [],
    },
  ];

  const toggleData = [];

  return (
    <MainDashboardLayout sidebar={<DocumentationSidebar />}>
      <TopMenu
        {...{
          setDrawerFilterOpen: setIsFilterModalOpen,
          selectedMonth,
          setSelectedMonth,
          selectedYear,
          setSelectedYear,
          selectedOption,
          handleToggle,
          filterApplied: isFiltersApplied,
          toggleData,
          fromDate,
          setFromDate,
          toDate,
          setToDate,
          selectedFacility,
          setSelectedFacility,
          searchQuery,
          setSearchQuery,
          fetchData,
        }}
        heading="Downstream Leased Assets"
      />

      <TableDocument
        data={data}
        totalPages={totalPages}
        page={page}
        handleChangePage={handleChangePage}
        headers={heading}
        columnWidth={columnWidth}
      />

      {/* <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        filters={filterData}
        onFilterChange={handleFilterChange}
        title="Filter"
      /> */}
    </MainDashboardLayout>
  );
};

export default DownstreamLeasedAssetsDocuments;
